(() => {
  const normalize = (value) => (value || '').trim().toLowerCase();

  function openSizeChart(id) {
    const dialog = document.getElementById(id);
    if (dialog && !dialog.open) dialog.showModal();
  }

  function setupSizeCharts(root = document) {
    root.querySelectorAll('[data-hesaco-size-chart-open]').forEach((button) => {
      if (button.dataset.hesacoBound) return;
      button.dataset.hesacoBound = 'true';
      button.addEventListener('click', () => openSizeChart(button.dataset.hesacoSizeChartOpen));
    });
    root.querySelectorAll('.hesaco-size-chart-dialog').forEach((dialog) => {
      if (dialog.dataset.hesacoBound) return;
      dialog.dataset.hesacoBound = 'true';
      dialog.querySelector('[data-hesaco-size-chart-close]')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      dialog.querySelectorAll('[data-size-unit]').forEach((button) => {
        button.addEventListener('click', () => {
          const unit = button.dataset.sizeUnit;
          dialog.querySelectorAll('[data-size-unit]').forEach((item) => item.classList.toggle('is-active', item === button));
          dialog.querySelectorAll('td[data-in][data-cm]').forEach((cell) => {
            cell.textContent = cell.dataset[unit];
          });
        });
      });
    });
  }

  function swatchBackground(rawName) {
    const name = normalize(rawName).replace(/[_-]+/g, ' ').replace(/\s+/g, ' ').trim();
    const exact = {
      'black': '#111111', 'black2': '#111111', 'white': '#ffffff',
      'grey': '#a7a7a7', 'gray': '#a7a7a7', 'grey2': '#8f8f8f',
      'green': '#2d8b57', 'matcha': '#d7e6aa', 'khaki': '#c6b38f',
      'beige': '#e7ddcb', 'cream': '#f3eee4', 'ivory': '#f7f3e9',
      'pink': '#ef7da5', 'red': '#d92332', 'blue': '#4279bd',
      'light blue': '#dcecf4', 'slate blue': '#657889',
      'dark blue': '#172b49', 'navy': '#263149', 'navy blue': '#263149',
      'brown': '#8a5b45', 'orange': '#f47b39', 'yellow': '#f7df62',
      'purple': '#7a43ad',
      'leopard': '#c9a36b',
      'navycheetah': '#263149',
      'whitecheetah': '#f7f4ed'
    };
    if (exact[name]) return exact[name];
    const compact = name.replace(/\s/g, '');
    if (exact[compact]) return exact[compact];
    const tokens = name.split(' ').filter(Boolean);
    const colors = tokens.map((token) => exact[token]).filter((value) => value && !value.includes('gradient'));
    if (colors.length >= 2) {
      const step = 100 / colors.length;
      return 'linear-gradient(90deg,' + colors.map((color, i) => color + ' ' + (i * step) + '% ' + ((i + 1) * step) + '%').join(',') + ')';
    }
    if (colors.length === 1) return colors[0];
    if (name.includes('navy')) return '#263149';
    if (name.includes('black')) return '#111111';
    if (name.includes('white')) return '#ffffff';
    if (name.includes('grey') || name.includes('gray')) return '#a7a7a7';
    if (name.includes('pink')) return '#ef7da5';
    if (name.includes('green')) return '#2d8b57';
    if (name.includes('blue')) return '#4279bd';
    if (name.includes('red')) return '#d92332';
    return '#d8d8d5';
  }

  function setupColorSwatches(root = document) {
    root.querySelectorAll('[data-hesaco-color-name]').forEach((swatch) => {
      if (!swatch.style.getPropertyValue('--hesaco-swatch').trim()) {
        swatch.style.setProperty('--hesaco-swatch', swatchBackground(swatch.dataset.hesacoColorName));
      }
    });
  }

  function filterColorMedia() {
    const picker = document.querySelector('variant-picker');
    const gallery = document.querySelector('media-gallery');
    if (!picker || !gallery) return;
    const selected = picker.querySelector('input[data-option-name="Color"]:checked, input[data-option-name="Colour"]:checked');
    if (!selected) return;
    const color = normalize(selected.value);
    const taggedImages = [...gallery.querySelectorAll('img[alt*="Color:"]')];
    if (!taggedImages.length) return;

    const mediaNodes = new Set();
    const thumbnailNodes = new Set();
    taggedImages.forEach((image) => {
      const matches = normalize(image.alt).includes('color: ' + color);
      const media = image.closest('.product-media-container, [data-media-id], [ref="slides[]"]');
      const thumbnail = image.closest('.slideshow-control__thumbnail, [data-thumbnail-id], button');
      if (media) {
        media.hidden = !matches;
        media.setAttribute('aria-hidden', matches ? 'false' : 'true');
        mediaNodes.add(media);
      }
      if (thumbnail && !mediaNodes.has(thumbnail)) {
        thumbnail.hidden = !matches;
        thumbnailNodes.add(thumbnail);
      }
    });

    const firstVisible = [...gallery.querySelectorAll('.slideshow-control__thumbnail, [data-thumbnail-id]')]
      .find((item) => !item.hidden);
    if (firstVisible && typeof firstVisible.click === 'function') firstVisible.click();
  }

  let swatchRefreshQueued = false;

  function queueSwatchRefresh() {
    if (swatchRefreshQueued) return;
    swatchRefreshQueued = true;
    window.requestAnimationFrame(() => {
      swatchRefreshQueued = false;
      setupColorSwatches();
    });
  }

  function observeVariantPickerRenders() {
    if (document.documentElement.dataset.hesacoSwatchObserver === 'true') return;
    document.documentElement.dataset.hesacoSwatchObserver = 'true';

    const observer = new MutationObserver((mutations) => {
      const hasNewSwatches = mutations.some((mutation) =>
        [...mutation.addedNodes].some((node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('[data-hesaco-color-name]') || node.querySelector?.('[data-hesaco-color-name]'))
        )
      );
      if (hasNewSwatches) queueSwatchRefresh();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', () => {
    setupSizeCharts();
    setupColorSwatches();
    observeVariantPickerRenders();
    window.setTimeout(filterColorMedia, 100);
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('input[data-option-name="Color"], input[data-option-name="Colour"]')) {
      window.setTimeout(() => {
        setupColorSwatches();
        filterColorMedia();
      }, 180);
    }
  });
  document.addEventListener('shopify:section:load', (event) => {
    setupSizeCharts(event.target);
    setupColorSwatches(event.target);
    observeVariantPickerRenders();
    window.setTimeout(() => {
      setupColorSwatches();
      filterColorMedia();
    }, 100);
  });
})();